<template>
  <ul :class="classes" :style="styles">
    <slot></slot>
  </ul>
</template>
<script>
import "./bottom-navigation.less";
import { oneOf, findComponentsDownward, findComponentsUpward } from "iview/src/utils/assist";
import Emitter from "iview/src/mixins/emitter";

const prefixCls = "bottom-navigation";

export default {
  name: "BottomNavigation",
  mixins: [Emitter],
  props: {
    theme: {
      validator(value) {
        return oneOf(value, ["light", "dark", "primary"]);
      },
      default: "light"
    },
    activeName: {
      type: [String, Number]
    },
    openNames: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      currentActiveName: this.activeName,
      openedNames: []
    };
  },
  computed: {
    classes() {
      let theme = this.theme;

      return [`${prefixCls}`, `${prefixCls}-${theme}`];
    },
    styles() {
      let style = {};

      return style;
    }
  },
  methods: {
    updateActiveName() {
      if (this.currentActiveName === undefined) {
        this.currentActiveName = -1;
      }

      this.broadcast("BottomNavigationItem", "on-update-active-name", this.currentActiveName);
    },
    updateOpenKeys(name) {
      let names = [...this.openedNames];
      const index = names.indexOf(name);
      if (index >= 0) {
        let currentSubmenu = null;
        findComponentsDownward(this, "BottomNavigationItem").forEach(item => {
          if (item.name === name) {
            currentSubmenu = item;
            item.opened = false;
          }
        });
        findComponentsUpward(currentSubmenu, "BottomNavigationItem").forEach(item => {
          item.opened = true;
        });
        findComponentsDownward(currentSubmenu, "BottomNavigationItem").forEach(item => {
          item.opened = false;
        });
      } else {
        findComponentsDownward(this, "BottomNavigationItem").forEach(item => {
          if (item.name === name) item.opened = true;
        });
      }
      let openedNames = findComponentsDownward(this, "BottomNavigationItem")
        .filter(item => item.opened)
        .map(item => item.name);
      this.openedNames = [...openedNames];
      this.$emit("on-open-change", openedNames);
    },
    updateOpened() {
      const items = findComponentsDownward(this, "BottomNavigationItem");

      if (items.length) {
        items.forEach(item => {
          if (this.openedNames.indexOf(item.name) > -1) item.opened = true;
          else item.opened = false;
        });
      }
    },
    handleEmitSelectEvent(name) {
      this.$emit("on-select", name);
    }
  },
  mounted() {
    this.updateActiveName();
    this.openedNames = [...this.openNames];
    this.updateOpened();
    this.$on("on-bottom-navigation-item-select", name => {
      this.currentActiveName = name;
      this.$emit("on-select", name);
    });
  },
  watch: {
    openNames(names) {
      this.openedNames = names;
    },
    activeName(val) {
      this.currentActiveName = val;
    },
    currentActiveName() {
      this.updateActiveName();
    }
  }
};
</script>